<template>
    <p v-if="isHeader" :style="tmpTheme">购物车<span id="topcartnum">({{getLogin?totals:'0'}})</span></p>
    <p v-else  class="cartCount" :style="tmpTheme" id="rightcartnum">{{totals?totals:'0'}}</p>
</template>

<script>
	export default {
		name: 'calc-num',
		props: {
			isHeader: {
				type: Boolean,
				default () {
					return false;
				}
			},
			getLogin:{
				type: Boolean,
				default () {
					return false;
				}
			},
		},
		data () {
			return {
				totals:0,
			};
		},
		computed:{
			tmpTheme(){
				return {
                '--bgColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.bgColor:'#fff',
                '--fontColor':this.$store.state.sysConfig.colorConfig?this.$store.state.sysConfig.colorConfig.fontColor:'#fff'
            };
			}
		},
		created () {
			const _this = this;
            this.totals = Number(localStorage.getItem("cartNum") || 0);
			this.getCartNum()
		},
		methods: {
			getCartNum(){
				this.$api.getCartNum({}).then(res=>{
					localStorage.setItem("cartNum", res.data.data || 0);
					this.syncCartNum(res.data.data)
				})
			},
            syncCartNum(cartCount){
                this.totals = cartCount;
				localStorage.setItem("cartNum",this.totals);
            }
		}
	};
</script>
<style scoped lang="scss">
.cartCount{
	padding: 0px 3px; 
	font-size: 12px; 
	min-width: 15px;
	height: 15px; 
	line-height: 15px; 
	background: var(--bgColor,#a41111); 
	text-align: center; 
	color: rgb(255, 255, 255);
	border-radius: 50px;
	position: absolute;
	top: -5px;
    left: 33px;
}
.menurightBox .shopcarArea p{
    color: var(--bgColor);
}
.shoppcar>a>p:nth-child(2) {
    color: var(--fontColor,#e9000d);
}
</style>